import { apiService } from '@/lib/axios';

/**
 * Start a new revision of a released document and land on the new draft's
 * edit page. Used by Periodic Review (master list) and NEW REVISION (detail).
 *
 * @param {string} documentId
 * @param {object} deps
 * @param {(path: string) => void} deps.navigate
 * @param {(title: string, msg: string, kind?: string) => void} deps.notify
 */
export const startNewRevision = async (documentId, { navigate, notify }) => {
  try {
    const response = await apiService.documents.revise(documentId);

    if (response.data.success) {
      notify(
        'New Revision Created',
        `Revision ${response.data.data.revision} created.`,
        'success'
      );
      navigate(`/document/${documentId}/edit`);
    } else {
      throw new Error(response.data.error || 'Failed to create a new revision');
    }
  } catch (error) {
    notify(
      'Revision Failed',
      error.response?.data?.error || error.message,
      'error'
    );
  }
};
